module.exports = __webpack_public_path__ + "static/img/195b9ea3b73eb3d002f4e534c085f883.8e4c585c.jpg";